import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=6bd012bf&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"
import style0 from "./loader.vue?vue&type=style&index=0&id=6bd012bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd012bf",
  null
  
)

export default component.exports